import React from 'react';
// src/components/Sections/ContactSection.js
import { ContactForm } from '../Forms/ContactForm.js';

export const ContactSection = () => {
  const smsMessage = encodeURIComponent("Hi Cassidy! I'd love to book a photography session.");

  return React.createElement("section", {
    id: "contact",
    className: "scroll-mt-24 py-20 md:py-24 bg-gray-900 text-white"
  },
    React.createElement("div", {
      className: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
    },
      React.createElement("div", {
        className: "grid grid-cols-1 lg:grid-cols-2 gap-12"
      },
        React.createElement("div", {
          className: "order-2 lg:order-1"
        },
          React.createElement("h2", {
            className: "text-4xl font-bold mb-6"
          }, "Let's Create Something Beautiful"),
          React.createElement("p", {
            className: "text-teal-200 font-medium mb-3"
          }, "Usually replies within 24 hours"),
          React.createElement("p", {
            className: "text-gray-300 text-lg leading-relaxed mb-6"
          }, "Ready to book your session? I'd love to hear about your vision and discuss how we can capture your special moments together."),

          React.createElement("div", {
            className: "grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8"
          },
            React.createElement("a", {
              href: `sms:+16069226307?body=${smsMessage}`,
              className: "text-center rounded-lg border border-teal-300/40 bg-teal-500/20 px-4 py-3 text-teal-100 font-medium hover:bg-teal-500/30 transition-colors"
            }, "Text Cassidy"),
            React.createElement("a", {
              href: "tel:+16069226307",
              className: "text-center rounded-lg border border-cyan-300/40 bg-cyan-500/20 px-4 py-3 text-cyan-100 font-medium hover:bg-cyan-500/30 transition-colors"
            }, "Call (606) 922-6307"),
            React.createElement("a", {
              href: "mailto:cassidy@cassidysullivanphotography.com",
              className: "text-center rounded-lg border border-white/30 bg-white/10 px-4 py-3 text-white font-medium hover:bg-white/20 transition-colors"
            }, "Email Cassidy")
          ),
          
          React.createElement("div", {
            className: "space-y-4 mb-8"
          }, 
            React.createElement("div", {
              className: "flex items-center space-x-3"
            },
              React.createElement("svg", {
                className: "h-6 w-6 text-teal-400",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor"
              },
                React.createElement("path", {
                  d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                })
              ),
              React.createElement("a", {
                href: "tel:+16069226307",
                className: "text-white underline-offset-4 transition-colors hover:text-teal-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 rounded-sm"
              }, "(606) 922-6307")
            ),
            React.createElement("div", {
              className: "flex items-center space-x-3"
            },
              React.createElement("svg", {
                className: "h-6 w-6 text-teal-400",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor"
              },
                React.createElement("path", {
                  d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                }),
                React.createElement("polyline", { points: "22,6 12,13 2,6" })
              ),
              React.createElement("a", {
                href: "mailto:cassidy@cassidysullivanphotography.com",
                className: "break-all text-white underline-offset-4 transition-colors hover:text-teal-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 rounded-sm"
              }, "cassidy@cassidysullivanphotography.com")
            ),
            React.createElement("div", {
              className: "flex items-center space-x-3"
            },
              React.createElement("svg", {
                className: "h-6 w-6 text-teal-400",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor"
              },
                React.createElement("path", {
                  d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                }),
                React.createElement("circle", { cx: "12", cy: "10", r: "3" })
              ),
              React.createElement("span", null, "Based in Lexington, KY • Serving Kentucky & surrounding areas")
            )
          ),

          React.createElement("div", {
            className: "flex space-x-4"
          },
            React.createElement("a", {
              href: "https://www.instagram.com/cassidysullivanphotography/",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": "Instagram (opens in a new tab)",
              className: "inline-flex rounded-md p-1 text-gray-400 transition-colors hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
            },
              React.createElement("svg", {
                className: "h-8 w-8",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                "aria-hidden": "true"
              },
                React.createElement("path", {
                  d: "M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5zm5.25-2a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z"
                })
              )
            ),
            React.createElement("a", {
              href: "https://www.facebook.com/CSullivanPortraits/",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": "Facebook (opens in a new tab)",
              className: "inline-flex rounded-md p-1 text-gray-400 transition-colors hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
            },
              React.createElement("svg", {
                className: "h-8 w-8",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                "aria-hidden": "true"
              },
                React.createElement("path", {
                  d: "M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.19 2.23.19v2.46h-1.25c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z"
                })
              )
            ),
            React.createElement("a", {
              href: "mailto:cassidy@cassidysullivanphotography.com",
              "aria-label": "Email Cassidy",
              className: "inline-flex rounded-md p-1 text-gray-400 transition-colors hover:text-teal-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-300 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
            },
              React.createElement("svg", {
                className: "h-8 w-8",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "aria-hidden": "true"
              },
                React.createElement("path", {
                  d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                }),
                React.createElement("polyline", { points: "22,6 12,13 2,6" })
              )
            )
          )
        ),

        React.createElement("div", {
          className: "order-1 lg:order-2"
        },
          React.createElement(ContactForm)
        )
      )
    )
  );
};